import request from '@/utils/request'

// 获取签到配置
export function getSignConfig(data) {
  return request({
    url: '/admin/activity/webSignConfig/get',
    method: 'post',
    data
  })
}

// 保存签到配置
export function saveSignConfig(data) {
  return request({
    url: '/admin/activity/webSignConfig/save',
    method: 'post',
    data
  })
}

// 签到记录
export function getSignRecordList(data) {
  return request({
    url: '/admin/activity/webSignRecord/list',
    method: 'post',
    data
  })
}
